
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pocasie",
      function () {
        return require("private-next-pages/[region]/[resort]/pocasie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pocasie"])
      });
    }
  